import { render, staticRenderFns } from "./GraficosSignosVitales.vue?vue&type=template&id=34e2f1a8"
import script from "./GraficosSignosVitales.vue?vue&type=script&lang=js"
export * from "./GraficosSignosVitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports